import * as React from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

import { AddContactsTableContainer } from './AddContactsTableContainer';
import {
    getContactsByFacility,
    openFacilityContactModal,
    updateSelectedContact
} from '../../actions/manageFacilityActions';
import { IfacilityContact } from '../../models';

interface Iprops {
    meta: any;
    handler: any;
    pristine: boolean;
    errors: any;
    submitted: boolean;
    getContactsByFacility: typeof getContactsByFacility;
    openFacilityContactModal: typeof openFacilityContactModal;
    updateSelectedContact: typeof updateSelectedContact;
}

const Control = (props: Iprops) => {
    const { facilityID } = props.meta;
    React.useEffect(() => {
        if (facilityID) {
            props.getContactsByFacility(facilityID);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [facilityID]);

    if (props.meta.remove) {
        return null;
    }
    const readOnly = props.handler().disabled;
    const openAdd = () => {
        props.updateSelectedContact();
        props.openFacilityContactModal();
    };
    const openPreview = (contact: IfacilityContact) => {
        props.updateSelectedContact(contact);
        props.openFacilityContactModal(true);
    };

    return (
        <Col xs={props.meta.colWidth} className="facility-contacts-inline">
            <AddContactsTableContainer
                colorButton={props.meta.colorButton}
                facilityID={facilityID}
                readOnly={readOnly}
                onEditContact={() => props.openFacilityContactModal()}
                onPreviewContact={openPreview}
            />
            {!readOnly && (
                <Button
                    bsStyle="default"
                    className="pull-right"
                    style={{ marginTop: '10px' }}
                    onClick={openAdd}
                >
                    {props.meta.addLabel}
                </Button>
            )}
        </Col>
    );
};

const ConnectedControl = connect(null, {
    getContactsByFacility,
    openFacilityContactModal,
    updateSelectedContact
})(Control);

// react-reactive-form's `render` must be a plain function, not a connect() component
export const FacilityContactsTableControl = (props: any) => (
    <ConnectedControl {...props} />
);
